module.exports = __webpack_public_path__ + "static/floralheadband-da2ddd35310feb803c1dd3563e1fb402.png";